<template>
    <div id="wapper">
        <div class="header" v-if="active != 2">
            <div v-if="chargingShow == 0">产业园</div>
            <div v-else @click="chargingShow = 0"><img src="@/assets/img/return.png"> 屋面光伏系统</div>
        </div>
        <div class="timer" v-if="active != 2">
            <span>{{ timeDate }} &nbsp;&nbsp;&nbsp;{{ getWeekDate }}</span><span class="now">{{ timeNow }}</span>
        </div>
        <div class="return" v-if="active == 2" @click="active = 0"><img src="@/assets/img/return2.png" alt=""></div>
        <!-- 监控 -->
        <!-- <div class="video" >
            <div class="item" v-for="(item, index) in videoList" :class="{ 'full': item.isFull }" :key="item.id">
                <div class="box">
                    <video width="100%" muted :id="item.ref" height="100%" style="object-fit:fill"></video>
                </div>
                <div class="inall" v-if="!item.isFull">
                    <span @click="full(item, index)">
                        全屏
                    </span>
                </div>
                <div v-else class="all" @click="full(item, index)">
                    取消全屏
                </div>
                <div class="name">{{ item.name }}</div>

                <Photovoltaic v-if="PhotovoltaicShow && index == 0"></Photovoltaic>
            </div>
        </div> -->
        <Monitor v-show="active!=2"></Monitor>
        <div class="body" v-if="chargingShow == 0">
            <div class="item" v-for="(item, index) in list" :key="index" v-if="active == index && active != 2">
                <img :src="item.img" alt="">
            </div>
            <iframe src="https://local.vrmaker.vip:1443/wisdom_building/#/" frameborder="0" v-if="active == 2" width="100%"
                height="100%" allowfullscreen="allowfullscreen"></iframe>
        </div>
        <div class="body" v-else-if="active == 0">
            <div class="item" v-if="chargingShow == 1"><img src="@/assets/img/8.gif" alt=""></div>
            <div class="item" v-if="chargingShow == 2"><img src="@/assets/img/9.gif" alt=""></div>
        </div>
        <div class="charging button" @click="chargingShow = 1" v-if="active == 0 && chargingShow == 0">
            光储充系统
        </div>
        <div class="charging2 button" @click="chargingShow = 2" v-if="active == 0 && chargingShow == 0">
            3#1配电房
        </div>
        <div class="charging2 button" @click="chargingShow = 2" v-if="active == 0 && chargingShow == 0"
            style="margin-left: -377px;margin-top: -50px;">
            3#2配电房
        </div>
        <div class="charging2 button" @click="chargingShow = 2" v-if="active == 0 && chargingShow == 0"
            style="margin-left: -106px;margin-top: -116px;">
            2#1配电房
        </div>
        <!-- 安防监控 -->
        <Security v-if="active == 3"></Security>
        <!-- <div class="Security" v-if="active == 3" @click="buoomShow = !buoomShow">
            <div class="buoom" v-show="buoomShow" @click.stop="">
                <div class="name">光伏车棚1处</div>
                <div class="item" v-for="(item, index) in videoList2" :class="{ 'full': item.isFull }" :key="item.id">
                    <div class="box">
                        <video width="100%" muted :id="item.ref" height="100%" style="object-fit:fill"></video>
                    </div>
                    <div class="inall" v-if="!item.isFull">
                        <span @click.stop="full(item, index)">
                            全屏
                        </span>
                    </div>
                    <div v-else class="all" @click.stop="full(item, index)">
                        取消全屏
                    </div>
                    <Photovoltaic v-if="PhotovoltaicShow&&index==0"></Photovoltaic>
                </div>
            </div>
        </div> -->
        <!-- 运营管理 -->
        <div class="operation" v-if="active == 6" @click="operationshow = !operationshow">
            <img src="@/assets/img/box2.png" alt="" v-if="operationshow">
        </div>
        <div class="footer" v-if="active != 2">
            <img src="@/assets/img/img5.png" alt="">
            <span v-for="(item, index) in buttonList" :key="index" :class="{ 'active': active == index }"
                @click="checkbutton(item, index)">{{ item }}</span>
        </div>
    </div>
</template>

<script>
import { dateFormat } from '../../util/DateUtil';
import { _getProjectCamera, _getCameraPlayAddress } from '../../api/power.js'
import dayjs from 'dayjs'
import Hls from 'hls.js'
import Photovoltaic from './Photovoltaic';
import Monitor from './Monitor';
import Security from './Security';
export default {
    components: {
        Photovoltaic,Monitor,Security
    },
    data() {
        return {
            PhotovoltaicShow: false,
            list: [
                {
                    id: 0,
                    img: require("../../assets/img/1.gif")
                },
                {
                    id: 1,
                    img: require("../../assets/img/2.gif")
                },
                {
                    id: 2,
                    img: require("../../assets/img/3.png")
                },
                {
                    id: 3,
                    img: require("../../assets/img/4.gif")
                },
                {
                    id: 4,
                    img: require("../../assets/img/5.gif")
                },
                {
                    id: 5,
                    img: require("../../assets/img/6.gif")
                },
                {
                    id: 6,
                    img: require("../../assets/img/gif7.jpg")
                }
            ],
            buttonList: ['智能微网', "能源管理", "楼宇自控", "安防监控", "智慧停车", "智慧消防", "运营管理"],
            active: 0,
            chargingShow: 0, //首页切换
            timeNow: "",
            timer: null,
            videoList2: [
                {
                    id: 1,
                    isFull: false,
                    ref: 'video5',
                    hls: null,
                    video: null,
                }],
            videoList: [
                {
                    id: 1,
                    isFull: false,
                    ref: 'video1',
                    hls: null,
                    video: null,
                },
                {
                    id: 2,
                    isFull: false,
                    ref: 'video2',
                    hls: null,
                    video: null,
                },
                {
                    id: 3,
                    isFull: false,
                    ref: 'video3',
                    hls: null,
                    video: null,
                },
                {
                    id: 4,
                    isFull: false,
                    ref: 'video4',
                    hls: null,
                    video: null,
                },
            ],
            buoomShow: false,
            operation: false
        }
    },
    computed: {
        timeDate() {
            return dateFormat('YYYY年mm月dd日', new Date());
        },
        getWeekDate() {
            let weeks = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
            let date = new Date();
            let day = date.getDay();
            return weeks[day];
        }
    },
    watch:{
        
    },
    mounted() {
        this.timer = setInterval(() => {
            this.NowTime()
        }, 1000)
        this.getProjectCamera()
    },
    methods: {
        full(item, index) {
            this.videoList2[index].isFull = !this.videoList2[index].isFull
            if (index == 0) {
                if (this.videoList2[index].isFull) {
                    this.PhotovoltaicShow = true
                } else {
                    this.PhotovoltaicShow = false
                }
            }
        },
        checkbutton(item, index) {
            this.active = index;
            this.chargingShow = 0
            this.buoomShow = false
        },
        NowTime() {
            this.timeNow = dayjs().format('HH:mm:ss')
        },

        async getProjectCamera() {
            try {
                let res = await _getProjectCamera({
                    projectId: this.$store.getters.projectId
                })

                let list = res.data.data.devices.filter(item => {
                    let camera = JSON.parse(item.device_details)
                    return camera.ysyDeviceSerial
                })
                console.log(list);
                this.showCamera(list)
            } catch (err) {
                console.log(err)
            }

        },
        showCamera(list) {
            let _this = this

            let showCameraList = []
            showCameraList = list.slice(0, 4)

            console.log(showCameraList)

            showCameraList.forEach(async (item, index) => {
                let camera = JSON.parse(item.device_details)
                let sys = await _getCameraPlayAddress({
                    channelNo: camera.ysyChannel,
                    deviceSerial: camera.ysyDeviceSerial,
                    protocol: 2
                })
                _this.videoList[index]['name'] = item.device_name
                // _this.getStream(sys.data.data, _this.videoList[index].ref)
                 if(index==0){
                    _this.getStream2(sys.data.data, _this.videoList2[index].ref)
                }

            })
        },
        getStream(url, id) {
            if (Hls.isSupported()) {
                let current = this.videoList.find(item => item.ref == id)
                console.log(current);
                if (!current.hls) {
                    current.hls = new Hls()
                    current.video = document.getElementById(id);

                    current.hls.loadSource(url);
                    current.hls.attachMedia(current.video)
                    current.hls.on(Hls.Events.MANIFEST_PARSED, () => {
                        current.video.play();
                        console.log("加载成功");
                    });
                }

            }
        },
        getStream2(url, id) {
            if (Hls.isSupported()) {
                let current = this.videoList2.find(item => item.ref == id)
                console.log(current);
                if (!current.hls) {
                    current.hls = new Hls()
                    current.video = document.getElementById(id);

                    current.hls.loadSource(url);
                    current.hls.attachMedia(current.video)
                    current.hls.on(Hls.Events.MANIFEST_PARSED, () => {
                        current.video.play();
                        console.log("加载成功");
                    });
                }

            }
        },
    }

}
</script>

<style scoped lang="less">
#wapper {
    height: 100%;
    width: 100%;
    overflow: hidden;
    position: relative;

    .body {
        width: 100%;
        height: 100%;

        .item {
            width: 100%;
            height: 100%;

            img {
                width: 100%;
                height: 100%;
            }
        }
    }

    .return {
        position: absolute;
        left: 50%;
        z-index: 5;
        top: 50px;
        margin-left: -105px;
        cursor: pointer;
    }

    .operation {
        width: 146px;
        height: 50px;
        position: absolute;
        left: 50%;
        z-index: 5;
        top: 50%;
        margin-left: 113px;
        margin-top: -278rem;
        cursor: pointer;

        img {
            position: absolute;
            left: 0;
            z-index: 5;
            top: 100%;
        }
    }

    .Security {
        width: 50px;
        height: 50px;
        position: absolute;
        left: 50%;
        z-index: 15;
        top: 50%;
        margin-left: -50px;
        margin-top: 0px;
        cursor: pointer;

        .buoom {
            background: url("../../assets/img/box.png") no-repeat;
            width: 177px;
            height: 143px;
            position: absolute;
            left: 0;
            margin-left: -62px;
            z-index: 15;
            bottom: 100%;
            color: #ffffff;
            padding: 29px 10px 25px 10px;

            .name {
                position: absolute;
                top: 5px;
                left: 5px;
            }

            .box {
                height: 100%;
                width: 100%;
                position: relative;

                
            }
            .inall {
                    position: absolute;
                    color: #ffffff;
                    bottom: 25px;
                    right: 5px;
                    font-size: 14px;
                    padding: 0 10rem;
                    text-align: right;
                    cursor: pointer;
                }
            .full {
                width: 100vw;
                height: 100vh;
                position: fixed;
                top: 0;
                left: 0;
                // z-index: 15;
                background-color: #000000;
                margin: 0;

                .box {
                    // position: absolute;
                    // width: 100%;
                    // height: 100%;
                    // z-index: 11;
                    // z-index: 15;
                    position: absolute;
                    width: 1536px;
                    height: 937px;
                    left: 50%;
                    top: 50%;
                    margin-left: -768px;
                    margin-top: -468px;
                    transform: translate(0, 0);
                }

                .all {
                    position: fixed;
                    color: #ffffff;
                    bottom: 20px;
                    right: 0;
                    font-size: 20px;
                    padding: 0 10rem;
                    text-align: right;
                    cursor: pointer;
                    z-index: 11;
                }
            }
        }
    }

    // .video {
    //     position: absolute;
    //     bottom: 5px;
    //     right: 1%;
    //     color: #ffffff;
    //     z-index: 9;
    //     width: 446px;

    //     .item {
    //         width: 191px;
    //         display: inline-block;
    //         margin: 0 16px;
    //         position: relative;

    //         .box {
    //             width: 100%;
    //             height: 94rem;
    //             position: relative;
    //         }

    //         .inall {
    //             position: absolute;
    //             color: #ffffff;
    //             top: 70rem;
    //             right: 0;
    //             font-size: 14px;
    //             padding: 0 10rem;
    //             text-align: right;
    //             cursor: pointer;
    //         }
    //     }

    //     .name {
    //         font-size: 14rem;
    //         font-family: Source Han Sans CN;
    //         font-weight: 500;
    //         color: #E2EBF1;
    //         line-height: 30px;
    //     }

    //     .full {
    //         width: 100vw;
    //         height: 100vh;
    //         position: fixed;
    //         top: 0;
    //         left: 0;
    //         z-index: 10;
    //         background-color: #000000;
    //         margin: 0;

    //         .box {
    //             // position: absolute;
    //             // width: 100%;
    //             // height: 100%;
    //             // z-index: 11;
    //             position: absolute;
    //             width: 1536px;
    //             height: 937px;
    //             left: 50%;
    //             top: 50%;
    //             margin-left: -768px;
    //             margin-top: -468px;
    //             transform: translate(0, 0);
    //         }

    //         .name {
    //             display: none;
    //         }

    //         .all {
    //             position: fixed;
    //             color: #ffffff;
    //             bottom: 20px;
    //             right: 0;
    //             font-size: 20px;
    //             padding: 0 10rem;
    //             text-align: right;
    //             cursor: pointer;
    //             z-index: 11;
    //         }
    //     }
    // }

    .timer {
        position: absolute;
        right: 80px;
        z-index: 9;
        color: #ffffff;
        font-size: 15px;
        line-height: 40px;

        span {
            display: inline-block;
            vertical-align: middle;
            font-family: "zcoolqingkehuangyouti";
            font-size: 22px;
        }

        .now {
            font-size: 25px;
            margin-left: 25px;
            font-family: "zcoolqingkehuangyouti";
        }
    }

    .button {
        background: url("../../assets/img/img7.png") no-repeat;
        width: 117px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        font-size: 11px;
        color: #FFFFFF;
        padding-left: 20px;

    }

    .charging {
        position: absolute;
        left: 50%;
        z-index: 5;
        top: 50%;
        margin-left: 17%;
        margin-top: 4%;
        cursor: pointer;
    }

    .charging2 {
        position: absolute;
        left: 50%;
        z-index: 5;
        top: 50%;
        margin-left: -150px;
        margin-top: 3%;
        cursor: pointer;
        background: url("../../assets/img/img8.png") no-repeat;
        padding-left: 0px;
    }

    .header {
        font-size: 24px;
        font-family: YouSheBiaoTiHei;
        font-weight: 400;
        color: #FFFFFF;
        position: absolute;
        text-align: center;
        width: 100%;
        top: 10%;

        div {
            display: inline-block;
            cursor: pointer;
        }
    }

    .footer {
        position: fixed;
        bottom: 0;
        left: 50%;
        margin-left: -845px;
        width: 1690px;
        height: 117px;
        line-height: 147px;
        text-align: center;
        background: url("../../assets/img/img1.png") no-repeat;

        span {
            display: inline-block;
            color: #ffffff;
            font-size: 17px;
            text-align: center;
            line-height: 35px;
            width: 96px;
            height: 32px;
            background: url("../../assets/img/img6.png") no-repeat;
            margin: 0 10px;
            cursor: pointer;
        }

        .active {
            text-shadow: 0 0 1vh #13F2FF, 0 0 2vh #13F2FF, 0 0 3vh #13F2FF;
        }

        img {
            text-align: center;
            position: absolute;
            left: 49%;
            top: 20px
        }
    }
}</style>